import * as React from "react";
import * as ReactDOM from "react-dom";

interface ILoaderCompProps {
    show:boolean
}

interface ILoaderCompState {
}

export default class LoaderComp extends React.Component<ILoaderCompProps, ILoaderCompState>{

  	constructor(props:ILoaderCompProps){
        super(props);
    }

    render() {

        return (
            <div className="loader-container">
                <div className="spinner"></div>
            </div>
        );
    }
}

export class InitLoaderComp {
    constructor(show:boolean) {
        var div: HTMLDivElement = document.getElementById('loader_comp') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.render(<LoaderComp show={show} />, div);
            // for test
            setTimeout(()=>{
                ReactDOM.render(<LoaderComp show={!show} />, div);
            }, 3000);
        }
    }
}
